var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIMessagesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11238_34496)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9396 3.73141C26.6724 3.04 26.0559 2.06662 25.1818 1.38084C24.6771 0.984896 24.0746 0.606352 23.2468 0.356431C22.3645 0.0900237 21.2778 0 19.9253 0H7.55792C6.20539 0 5.11871 0.0900237 4.23638 0.356431C3.40875 0.606352 2.80614 0.984896 2.3014 1.38084C1.42715 2.06662 0.810672 3.04 0.54353 3.73141C0.00539417 5.12429 0 6.70481 0 7.70004V20.3C0 21.2953 0.00539417 22.8757 0.54353 24.2687C0.810672 24.9601 1.42715 25.9335 2.30127 26.6192C2.80601 27.0151 3.40849 27.3936 4.23625 27.6436C5.11859 27.91 6.20526 28 7.55779 28H19.9252C21.2777 28 22.3644 27.91 23.2467 27.6436C24.0743 27.3936 24.6769 27.0151 25.1817 26.6192C26.0558 25.9334 26.6723 24.96 26.9394 24.2687C27.4776 22.8757 27.483 21.2953 27.483 20.3V7.70004C27.483 6.70481 27.4777 5.12429 26.9396 3.73141Z",
    fill: "#3B71FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7407 4.86475C8.17308 4.86475 3.65967 8.66053 3.65967 13.3429C3.65967 16.3225 5.40097 18.7997 8.10642 20.3743C8.96127 20.872 8.16665 21.8824 7.42084 22.6779C7.02321 23.1021 7.08563 23.2338 7.6045 23.1015C10.2058 22.438 10.28 21.3759 11.4529 21.6018C12.1883 21.7435 12.9538 21.8211 13.7407 21.8211C19.3083 21.8211 23.8217 18.0254 23.8217 13.3429C23.8217 8.66053 19.3081 4.86475 13.7407 4.86475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11238_34496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.483,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMessagesIcon);
export default __webpack_public_path__ + "static/media/iMessagesIcon.9b5244158c52a35807b7eaac81bf7899.svg";
export { ForwardRef as ReactComponent };